module.exports = __webpack_public_path__ + "static/media/Microsoft Teams.56505f1d.svg";